export enum PaymentStatus {
  OnHold = "OnHold",
  Paid = "Paid",
  ToRefund = "ToRefund",
  Refunded = "Refunded",
  Investigate = "Investigate",
  Dismissed = "Dismissed",
  OnCredit = "OnCredit",
}
